module.exports = __webpack_public_path__ + "media/mobile-menu/close-2150aca1.svg";